import { useState } from "react";

import Modal from "../modal";
import InteractiveWelcomeModal from "./interactiveWelcomeModal";


function InteractiveWelcome(props) {

  // Define variables
  const [showModal, setShowModal] = useState(true);
  const [step, setStep] = useState(1);


  // Define functions
  function closeModal() {
    setShowModal(false);
  }


  // Screen components
  let modal;
  if( showModal ) {
    modal = (
      <Modal
        wrapperClass={'interactive-welcome'}
        windowClass={'interactive-welcome'}
        centerTitle={true}
        body={
          <InteractiveWelcomeModal
            closeModal={closeModal}
            step={step}
            setStep={setStep}
          />
        }
      />
    );
  }

  return (
    <>{modal}</>
  );
}

export default InteractiveWelcome;